// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"steps_wrapper__3LPjx","step":"steps_step__2vpzQ","ellipse":"steps_ellipse__1XJuj","number":"steps_number__2YggM","line":"steps_line__mV2ht","title":"steps_title__WzUdT"};